import { LOGO_SRC } from "@/constants/site";

export default function Watermark() {
  return (
    <>
      {/* Subtle dot pattern */}
      <div className="fixed inset-0 pointer-events-none watermark z-0" aria-hidden />
      {/* Large centered logo watermark at ~5% opacity */}
      <div className="fixed inset-0 pointer-events-none flex items-center justify-center z-0" aria-hidden>
        <img
          src={LOGO_SRC}
          alt=""
          className="w-[min(88vmin,900px)] h-auto opacity-[0.05] object-contain select-none"
          draggable={false}
        />
      </div>
    </>
  );
}
